<template>
  <v-container>
    <v-card max-width="1400px" class="mx-auto mt-10" weight="60px" >
      <v-card-title>
        <span v-if="!otpSent && !needEmail">Vérification Email</span>
        <span v-else-if="needEmail">Add Email</span>
        <span v-else>Enter your OPT </span>
      </v-card-title>
      <v-card-text>
        <!-- Formulaire d'ajout d'email -->
        <v-form v-if="needEmail">
          <v-text-field v-model="email" label="Adresse Email" required></v-text-field>
        </v-form>
        
        <!-- Formulaire d'envoi d'OTP -->
        <v-form v-else-if="!otpSent">
          <v-text-field 
    v-model="email" 
    label="Adresse Email" 
    v-if="email"
  />
        </v-form>
        
        <!-- Formulaire de saisie de l'OTP -->
        <v-form v-else>
          <v-text-field v-model="otp" label="Code OTP" required></v-text-field>
        </v-form>
        
        <!-- Message d'erreur ou succès -->
        <p v-if="message" :class="`text-${messageType}`">{{ message }}</p>
      </v-card-text>
      
      <v-card-actions>
        <v-btn color="primary" @click="resetForm">Cancel</v-btn>
        <v-btn
  v-if="needEmail"
  color="primary"
  :loading="isLoading"
  :disabled="isLoading"
  @click="addEmail"
>
  Add Email
</v-btn>
<v-btn
  v-else-if="!otpSent"
  color="primary"
  :loading="isLoading"
  :disabled="isLoading"
  @click="sendOtp"
>
  Send OTP
</v-btn>

        <v-btn v-else color="primary" @click="verifyOtp">Validate</v-btn>
      </v-card-actions>
    </v-card>
      <!-- Image finale, affichée après tout le formulaire -->
  <img src="/Group 219.png" alt="Illustration étape 1" class="mt-5">
  </v-container>


</template>
<script>
import axios from 'axios';

export default {
  data() {
    return {
      email: '', // Email récupéré
      loading: false, // État de chargement
      errorMessage: null, // Message d'erreur
      otp: "", // OTP saisi
      otpSent: false, // Indique si l'OTP a été envoyé
      needEmail: false, // Indique si l'utilisateur doit ajouter un email
      message: "", // Message de retour (succès ou erreur)
      messageType: "error", // Type de message : success / error
   
      isLoading: false,
    };
  },
  methods: {

   
    async fetchEmail() {
      this.loading = true;
      this.errorMessage = null;

      try {
        const response = await axios.get('/api/v1/savings/user-email/'); // URL de l'API
        this.email = response.data.email; // Récupérer et stocker l'email
        this.$store.dispatch('setEmail', this.email); // Mise à jour dans Vuex
      } catch (error) {
        this.errorMessage = error.response?.data?.error || "Erreur lors de la récupération de l'email.";
      } finally {
        this.loading = false;
      }
    },
    // Vérifier si l'utilisateur a un email et envoyer OTP
    async sendOtp() {
  this.message = "";
  this.isLoading = true; // Activer l'animation de chargement
  try {
    const response = await axios.post('/api/v1/savings/verify-email/');
    this.otpSent = true;
    this.message = response.data.success;
    this.messageType = "success";
  } catch (error) {
    if (error.response && error.response.data.error.includes("Your account does not have an email address yet. Please add one now.")) {
      this.needEmail = true;
    }
    this.message = error.response?.data?.error || "Error while sending the OTP.";
    this.messageType = "error";
  } finally {
    this.isLoading = false; // Désactiver l'animation de chargement
  }
},

async verifyOtp() {
    this.message = "";
    this.isLoading = true;
    console.log("OTP entered:", this.otp);

    try {
        const response = await axios.post('/api/v1/savings/validate-otp/', {
            otp_code: this.otp, 
           
        });

        this.$store.dispatch('updateVerificationStatus', true);
        this.message = response.data.success;
        this.messageType = "success";
        this.$store.commit('setSnackBarMessage', "Your OTP is valid for one hour.");
        this.$store.commit('setSnackBarColor', "teal darken-4");
        this.$store.commit('activateSnackBar', true);

        setTimeout(() => {
            this.$router.push('/savings/withdrawals/request');
        }, 1500);
    } catch (error) {
        console.error('Error:', error);
        if (error.response && error.response.status === 400) {
            this.message = error.response.data.error || "Invalid or expired OTP.";
        } else {
            this.message = "An unexpected error occurred. Please try again.";
        }
        this.messageType = "error";
    } finally {
        this.isLoading = false;
    }
},
// Ajouter l'email de l'utilisateur
async addEmail() {
  this.message = "";
  this.isLoading = true; // Activer l'animation de chargement
  try {
    await axios.post('/api/v1/savings/add-email/', { email: this.email });
    this.needEmail = false;
    await this.sendOtp(); // Relancer l'envoi de l'OTP après ajout
  } catch (error) {
    this.message = error.response?.data?.error || "Error while adding the email.";
    this.messageType = "error";
  } finally {
    this.isLoading = false;
  }
},

    resetForm() {
      this.email = "";
      this.otp = "";
      this.otpSent = false;
      this.needEmail = false;
      this.message = "";
      this.messageType = "error";
      this.$router.push('/savings');
    },
  },
  mounted() {
    this.fetchEmail(); // Récupérer l'email au montage du composant
  },
};
</script>

<style scoped>
.text-success { color: #1976D2; }
.text-error { color: red; }



.mt-5 {
  height: 700px;
  weight: 60px;
  margin-top: 150px; 
}
@media (max-width: 600px) {
  .mt-5 {
    height: 400px; /* Réduire la hauteur sur les petits écrans */
    width: 100%;   /* Faire en sorte que la largeur prenne 100% de la largeur de l'écran */
    margin-top: 50px; /* Réduire l'espace au-dessus */
  }
}
</style>
